import { pdfjs } from 'react-pdf';
import { useUnmount } from 'react-use';
import { useUIStore } from '@ContractBuilder/store/ui.store';
import { AnimatePresence } from 'motion/react';

import { PDFPreviewController } from './controller/PDFPreviewController';
import { usePDFPreviewStore } from './store/pdf-preview.store';

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

// validation-structure.ts also sets GlobalWorkerOptions.workerSrc for the attachment validation path.
// Both write the same URL; the singleton means whichever loads second is a no-op.
pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

export const PDFPreviewDrawer = () => {
  const { isOpen, togglePDFPreview } = useUIStore(({ isPDFPreviewOpen, togglePDFPreview }) => ({
    isOpen: isPDFPreviewOpen,
    togglePDFPreview,
  }));
  const reset = usePDFPreviewStore((state) => state.reset);

  const handleExitComplete = () => {
    reset();
  };

  useUnmount(() => {
    if (isOpen) {
      return togglePDFPreview();
    }
  });

  return (
    <AnimatePresence initial={false} onExitComplete={handleExitComplete}>
      {isOpen && <PDFPreviewController />}
    </AnimatePresence>
  );
};
